import loadable from '@loadable/component';
import React from 'react';

import AboveTheFoldServerRenderer from 'components/essentials/AboveTheFoldServerRenderer';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useIsBrowser from 'hooks/useIsBrowser';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
// CON-7309: Temporarily removed to help isolate cause of performance issues
// import BrowserOnly from 'components/consumer/BrowserOnly';

const RecentlyViewed = loadable(() =>
  import('components/consumer/recently-viewed')
);

// CON-7309: Temporarily removed to help isolate cause of performance issues
// const RecommendedForYouCarousel = loadable(() =>
//   import('components/consumer/ProductCardCarousel/RecommendedForYouCarousel')
// );

const PDPFooterInner = () => {
  const { data } = usePDPBasicDetails();
  const isBrowser = useIsBrowser();

  return (
    <>
      {/* BazaarVoice carousel: only render in browser */}
      {!!isBrowser && (
        <div
          data-crl8-container-id="product"
          data-crl8-filter={`productId:${data?.sku}`}
          data-crl8-lazy-load-experience="true"
        />
      )}

      <AboveTheFoldServerRenderer disableOnServer>
        <RecentlyViewed currentPDPProduct={data?.id} />
      </AboveTheFoldServerRenderer>

      {/* CON-7309: Temporarily removed to help isolate cause of performance issues */}
      {/* <AboveTheFoldServerRenderer disableOnServer>
        <BrowserOnly>
          <RecommendedForYouCarousel currentPDPProduct={data?.id} />
        </BrowserOnly>
      </AboveTheFoldServerRenderer> */}
    </>
  );
};

const PDPFooter = props => (
  <SuspenseWithLoader>
    <PDPFooterInner {...props} />
  </SuspenseWithLoader>
);

export default PDPFooter;
